
export const selectStyle = { maxWidth: '250px' }

export const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', marginTop: '39px', height: '46px', cursor: 'pointer' }

export const monthList = [{ value: '01', label: 'January' }, { value: '02', label: 'February' }, { value: '03', label: 'March' }, { value: '04', label: 'April' }, { value: '05', label: 'May' }, { value: '06', label: 'June' },
{ value: '07', label: 'July' }, { value: '08', label: 'August' }, { value: '09', label: 'September' }, { value: '10', label: 'October' }, { value: '11', label: 'November' }, { value: '12', label: 'December' }]

export const monthListWithAll = [{ value: '', label: 'All' }, { value: '01', label: 'January' }, { value: '02', label: 'February' }, { value: '03', label: 'March' }, { value: '04', label: 'April' }, { value: '05', label: 'May' }, { value: '06', label: 'June' },
{ value: '07', label: 'July' }, { value: '08', label: 'August' }, { value: '09', label: 'September' }, { value: '10', label: 'October' }, { value: '11', label: 'November' }, { value: '12', label: 'December' }]

export const subscriptionList = ['All Subscriptions', 'New Subscriptions', 'Canceled Subscriptions', 'Expired Subscriptions']

export const orderStatus = [
    { label: 'All', value: 'All' },
    { label: 'Assigned', value: 'ASSIGNED' },
    { label: 'Shipped', value: 'SHIPPED' },
    { label: 'Delivered', value: 'DELIVERED' },
    { label: 'Claimed', value: 'CLAIM' },
    { label: 'Canceled', value: 'CANCELED' },
    { label: 'On Hold', value: 'HOLD' },
    { label: 'Completed', value: 'COMPLETE' }
];

export const pickupOrderStatus = [
    { label: 'All', value: 'ALL' },
    { label: 'Assigned', value: 'ASSIGNED' },
    { label: 'Rescheduled', value: 'RESCHEDULED' },
    { label: 'Picked Up', value: 'PICKEDUP' },
    { label: 'On Hold', value: 'HOLD' },
    { label: 'Claimed', value: 'CLAIM' },
    { label: 'Canceled', value: 'CANCELED' },
    { label: 'Completed', value: 'COMPLETE' }
];

export const claimLists = ['All Claim', 'Pending Claim', 'Resolved Claim', 'Escalated Claim']

export const commissionTypeArr = [
    { value: 'BOTH', label: 'All' },
    { value: 'INTERNAL', label: 'Internal' },
    { value: 'AFFILIATE', label: 'Affiliate' }
]

export const pickupOrderTableHeader = [
    { title: 'Order Id', },
    { title: 'PO Number', },
    { title: 'Ref Number', },
    { title: 'Pickup Location', },
    { title: 'Pickup City', },
    { title: 'Pickup State', },
    { title: 'Pickup Zip', },
    { title: 'Buyer', },
    { title: 'Buyer City', },
    { title: 'Buyer State', },
    { title: 'Buyer Zip', },
    { title: 'Seller', },
    { title: 'Seller City', },
    { title: 'Seller State', },
    { title: 'Seller Zip', },,
    { title: 'Requested Date', },
    { title: 'Actual Pickup Date', },
    { title: 'Quantity', },
    { title: 'Status', }
]